





































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import storeSecondOpinion from "@/store/modules/PermintaanSecondOpinionStore";
import PermintaanSecondOpinionSvc from "@/services/PermintaanSecondOpinion";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component({
  components: { CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPermintaanSecondOpinion extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  dialogForm = false;
  isEditing = false;
  formValid = false;
  saving = false;
  modalSaksiPasien = false;
  modalTtdSaksiRs = false;
  saksiPasienNama = "";
  selectedItem: any = null;

  form: any = this.getEmptyForm();

  agamaOptions = ["Islam", "Kristen", "Katolik", "Hindu", "Buddha", "Konghucu", "Kepercayaan"];

  headers = [
    { text: "No", value: "no", sortable: false, width: 50 },
    { text: "Pemohon", value: "pemohon_nama" },
    { text: "Hubungan", value: "hubungan" },
    { text: "Diagnosa", value: "diagnosa" },
    { text: "Status TTD", value: "status", sortable: false, width: 120 },
    { text: "Aksi", value: "aksi", sortable: false, width: 200 }
  ];

  mounted() {
    storeSecondOpinion.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  get loading() { return storeSecondOpinion.loading; }
  get items() { return storeSecondOpinion.items; }
  get dokterList() { return storeDokter.listAll; }
  get currentUserId() { return userModule.user?.id; }

  get pasienData() {
    const p = storePasien.identitasPasien;
    if (!p) return { nama: "", usia: "", jk: "", agama: "", alamat: "" };
    return {
      nama: p.nama || "",
      usia: p.usia || "",
      jk: p.jk || "",
      agama: p.agama || "",
      alamat: p.alamat || ""
    };
  }

  getEmptyForm() {
    return {
      pemohon_nama: "",
      pemohon_umur: null,
      pemohon_jk: null,
      pemohon_no_hp: "",
      pemohon_agama: "",
      pemohon_alamat: "",
      hubungan: "",
      dpjp_user_id: RegisterKunjungan.register?.dokter?.id || null,
      diagnosa: "",
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate()
    };
  }

  formatHubungan(val: string) {
    const map: Record<string, string> = {
      diri_sendiri: "Pasien Sendiri",
      orang_tua: "Orang Tua",
      suami: "Suami",
      istri: "Istri"
    };
    return map[val] || val;
  }

  isItemFullySigned(item: any) {
    return item.signed_saksi_pasien && item.signed_saksi_rs;
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("permintaan_second_opinion", "create");
  }

  canEditItem(item: any) {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("permintaan_second_opinion", "edit")) return false;
    return !this.isItemFullySigned(item) && item.creator_user_id == this.currentUserId;
  }

  canDeleteItem(item: any) {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("permintaan_second_opinion", "edit")) return false;
    return !this.isItemFullySigned(item) && item.creator_user_id == this.currentUserId;
  }

  canEditItemState(item: any) {
    if (this.readOnly) return false;
    return !this.isItemFullySigned(item) && item.creator_user_id == this.currentUserId;
  }

  canDeleteItemState(item: any) {
    if (this.readOnly) return false;
    return !this.isItemFullySigned(item) && item.creator_user_id == this.currentUserId;
  }

  refreshList() {
    storeSecondOpinion.getByRegister(this.register);
  }

  // ============ CREATE / EDIT ============

  openCreate() {
    this.form = this.getEmptyForm();
    this.isEditing = false;
    this.dialogForm = true;
  }

  openEdit(item: any) {
    if (this.isItemFullySigned(item)) return;
    this.form = {
      pemohon_nama: item.pemohon_nama || "",
      pemohon_umur: item.pemohon_umur,
      pemohon_jk: item.pemohon_jk,
      pemohon_no_hp: item.pemohon_no_hp || "",
      pemohon_agama: item.pemohon_agama || "",
      pemohon_alamat: item.pemohon_alamat || "",
      hubungan: item.hubungan || "",
      dpjp_user_id: item.dpjp_user_id,
      diagnosa: item.diagnosa || "",
      tempat_tanda_tangan: item.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: item.tgl_tanda_tangan || localISODate()
    };
    this.selectedItem = item;
    this.isEditing = true;
    this.dialogForm = true;
  }

  @Watch("form.hubungan")
  onHubunganChange(val: string) {
    if (val === "diri_sendiri") {
      const p = storePasien.identitasPasien;
      if (p) {
        this.form.pemohon_nama = p.nama || "";
        this.form.pemohon_jk = p.jk === "Laki-laki" ? "L" : p.jk === "Perempuan" ? "P" : p.jk;
        this.form.pemohon_agama = p.agama || "";
        this.form.pemohon_alamat = p.alamat || "";
        this.form.pemohon_no_hp = p.telp || "";
        if (p.tgl_lahir) {
          const birth = new Date(p.tgl_lahir);
          const now = new Date();
          this.form.pemohon_umur = Math.floor((now.getTime() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
        }
      }
    }
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        unit_id: userModule.user?.unit_id || "",
        ...this.form
      };

      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await PermintaanSecondOpinionSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await PermintaanSecondOpinionSvc.create(payload);
      }

      if (resp.data.status == "1" || resp.data.status == 1) {
        appModule.NoticeDelay("Permintaan Second Opinion berhasil disimpan");
        this.dialogForm = false;
        this.form = this.getEmptyForm();
        this.selectedItem = null;
        this.refreshList();
      }
    } finally {
      this.saving = false;
    }
  }

  // ============ SAKSI PASIEN (MANUAL MARK) ============

  openMarkSaksiPasien(item: any) {
    this.selectedItem = item;
    this.saksiPasienNama = item.saksi_pasien_nama || "";
    this.modalSaksiPasien = true;
  }

  async submitMarkSaksiPasien() {
    const resp = await PermintaanSecondOpinionSvc.markSaksiPasien(this.selectedItem.id, {
      saksi_pasien_nama: this.saksiPasienNama
    });

    if (resp.data.status == "1") {
      this.modalSaksiPasien = false;
      appModule.NoticeDelay("Berhasil menandai Saksi Pasien/Wali");
      this.refreshList();
    }
  }

  // ============ SAKSI RS (DIGITAL SIGN) ============

  openTtdSaksiRs(item: any) {
    this.selectedItem = item;
    this.modalTtdSaksiRs = true;
  }

  async passTtdSaksiRs(password: string) {
    const resp = await PermintaanSecondOpinionSvc.signSaksiRs(this.selectedItem.id, { password });

    if (resp.data.status == "1") {
      this.modalTtdSaksiRs = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Saksi RS");
      appModule.addMsgTtd("");
      this.refreshList();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtdSaksiRs = true;
    }
  }

  // ============ PDF & DELETE ============

  cetakPdf(item: any) {
    PermintaanSecondOpinionSvc.print(item.id);
  }

  async hapus(item: any) {
    if (!confirm("Yakin ingin menghapus permintaan second opinion ini?")) return;

    const resp = await PermintaanSecondOpinionSvc.destroy(item.id);
    if (resp.data?.status == 1 || resp.data?.status == "1") {
      appModule.NoticeDelay("Berhasil menghapus data");
      this.refreshList();
    }
  }
}
